module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921053834_T.47f59f62.jpg";